import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";

export default function PageHero({ title, subtitle, breadcrumb }) {
  return (
    <div className="hc-banner-gradient text-white">
      <div className="hc-container py-12 md:py-16">
        <div className="flex items-center gap-2 text-xs text-white/80">
          <Link to="/" className="inline-flex items-center gap-1 hover:text-white">
            <HomeIcon className="w-3.5 h-3.5" /> Home
          </Link>
          <span>›</span>
          <span className="text-white">{breadcrumb || title}</span>
        </div>
        <h1 className="mt-4 text-3xl md:text-5xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="mt-3 text-white/90 max-w-2xl text-base md:text-lg leading-relaxed">{subtitle}</p>}
      </div>
    </div>
  );
}
